import { logError } from '@/utils/general'

export default defineNuxtPlugin(() => {
  const { getShield } = useShield()
  const router = useRouter()

  const warmUp = (path: string) => {
    // Skip warm up for non-signup routes
    if (!path.includes('/signup')) {
      return
    }

    // Shield instance is cached, so repeat calls do nothing
    getShield().catch(error => logError(error, { context: 'shield warmup' }))
  }

  onNuxtReady(() => warmUp(router.currentRoute.value.path))
  router.afterEach(to => warmUp(to.path))
})
